import { Controller } from "@hotwired/stimulus"
import { keepSubItemsExpanded } from "../lib/list_sub_items_preference"

// FD-901: a list row's sub-items chevron. The row's children live in a lazy turbo-frame
// that starts hidden; showing it is what makes Turbo fetch it (a lazy frame loads when it
// becomes visible), so a parent nobody opens costs no request.
//
// The frame's `hidden` attribute is the single source of truth for open/closed. The frame
// carries refresh="morph", so a broadcast page refresh reloads it rather than morphing it,
// and leaves its attributes alone: an open frame stays open. The chevron and aria-expanded
// live outside the frame and DO get morphed back to the server's closed markup, which is
// why #sync runs again on turbo:morph.
//
// Not a <details> + remembered-details (FD-891): that remembers ONE element's state under
// its own key, while "keep expanded" is one preference over every parent on the page; a
// <details>' `open` attribute would be morphed shut by every broadcast refresh; and the
// chevron sits inside the row's flex line, which holds links and menus a <summary> can't.
export default class extends Controller {
  static targets = ["frame", "toggle", "chevron"]

  connect() {
    if (keepSubItemsExpanded()) this.frameTarget.hidden = false
    this.sync()
  }

  toggle() {
    this.frameTarget.hidden = !this.frameTarget.hidden
    this.sync()
  }

  // The toolbar's "keep expanded" switch, broadcast on window.
  applyPreference(event) {
    this.frameTarget.hidden = !event.detail.expanded
    this.sync()
  }

  sync() {
    const open = !this.frameTarget.hidden
    this.toggleTarget.setAttribute("aria-expanded", String(open))
    this.chevronTarget.classList.toggle("rotate-90", open)
  }
}
